var _path, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewnoteicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14V1L8 1H10H11V3.5C11 4.05228 11.4477 4.5 12 4.5H15V5.625V7.5V14H1ZM14.6899 3.5L13.6515 2.64815L12 1.29341V3.5H14.6899ZM0 1C0 0.447715 0.447715 0 1 0H8H10H11.6423C11.8736 0 12.0977 0.0801673 12.2765 0.226851L14.2857 1.875L15.6342 2.9812C15.8658 3.17114 16 3.45486 16 3.75435V5.625V7.5V14C16 14.5523 15.5523 15 15 15H1C0.447715 15 0 14.5523 0 14V1Z",
    fill: "#b3b3b3"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        svg {\n          vertical-align: middle;\n          font-weight: 400;\n          fill: undefined;\n        }\n")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewnoteicon);
export default __webpack_public_path__ + "static/media/newnoteicon.3bb63e1bfb713c534857b5a3e65b5f3d.svg";
export { ForwardRef as ReactComponent };